import { render, staticRenderFns } from "./addOrderToShipmentId.vue?vue&type=template&id=5599a7ec&"
import script from "./addOrderToShipmentId.vue?vue&type=script&lang=js&"
export * from "./addOrderToShipmentId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports